 export default {
  "title": "Brian's Memory Map 2004-2014",
  "stations": [
    {"label":"High School Graduation","lines":["Mom","Dad","Brandon","Patricia", "Angela"]},
    {"label":"Broadway Dance Company","lines":["Hoang"]},
    {"label":"John Jay Ocho","lines":["Michelle S"]},
    {"label":"Freshmen Orientation","lines":["Patricia","Michelle S"]},
    {"label":"You Are My Joy Born","lines":["Stephanie"]},
    {"label":"Lerner Dance Practice","lines":["Calvin","Pris"]},
    {"label":"Low Library Steps","lines":["Pris"]},
    {"label":"Joybombing","lines":["Stephanie"]},
    {"label":"First CUNUFF","lines":["Hoang","Calvin","Pris"]},
    {"label":"Painting in John Jay","lines":["Hoang"]},
    {"label":"Mudd Roof","lines":["Pris"]},
    {"label":"UES Summer Roomies","lines":["Hoang","Calvin"]},
    {"label":"AAIFF Chinatown Film","lines":["Hoang","Calvin", "Kai"]},
    {"label":"Leopard Lounge","lines":["Calvin","Kai", "Amelia"]},
    {"label":"Staten Island Ferry","lines":["Hoang","Calvin","Kai","Amelia"]},
    {"label":"Hudson River","lines":["Kai"]},
    {"label":"Night of Chaos","lines":["Kai","Calvin","Amelia"]},
    {"label":"Six Flags","lines":["Calvin","Todd","Kai","Amelia","Ness"]},
    {"label":"Hera Gives Birth","lines":["Hoang","Calvin","Kai"]},
    {"label":"Belle and Sebastian","lines":["Kai"]},
    {"label":"Skydiving","lines":["Kai"]},
    {"label":"Guatemala","lines":["Kai"]},
    {"label":"France","lines":["Kai","Amelia","Ness"], "date":"5/27/07"},
    {"label":"Winter Camping","lines":["Kai"]},
    {"label":"East Coast Road Trip","lines":["Kai"]},
    {"label":"Dominican Republic","lines":["Kai"]},
    {"label":"Montreal","lines":["Kai"]},
    {"label":"First FC Dinner","lines":["Liza","Katie","Vicky"], "date": "4/25/08"},
    {"label":"How To Ride A Bike","lines":["Hoang"]},
    {"label":"Moving Into Metro","lines":["Calvin","Rahul","Teriha"], "date": "6/1/08"},
    {"label":"Natsumi Birthday","lines":["Calvin","Rahul","Teriha","Vicky"]},
    {"label":"Skydiving","lines":["Liza","Katie","Vicky"], "date": "6/9/08"},
    {"label":"A First Goodbye","lines":["Calvin","Teriha","Liza","Ness"]},
    {"label":"Ice Skating","lines":["Pris"], "date": "11/17/08"},
    {"label":"Survival Camping","lines":["Liza","Katie","Vicky"], "date": "11/17/08"},
    {"label":"Pumpkin Picking","lines":["Brandon","Calvin","Rahul","Teriha","Liza","Katie","Vicky"], "date": "11/20/08"},
    {"label":"Trapezing","lines":["Rahul","Liza","Katie","Vicky"], "date": "12/15/08"},
    {"label":"Adirondacks","lines":["Calvin","Christian","Liza","Vicky"], "date": "3/13/09"},
    {"label":"Monterey / Salinas","lines":["Pris"], "date": "5/19/09"},
    {"label":"Time's Up Film Shootout","lines":["Calvin","Rahul","Todd","Shakthi"], "date": "7/13/09"},
    {"label":"Summerscape","lines":["Calvin","Rahul","Todd","Christian","Liza","Katie","Vicky","Shakthi"], "date": "7/13/09"},
    {"label":"Silent Camping","lines":["Liza","Katie","Vicky"], "date": "8/8/09"},
    {"label":"Fire Island","lines":["Teriha"], "date": "9/4/09"},
    {"label":"Storm King & Palaia","lines":["Teriha"], "date": "9/19/09"},
    {"label":"Warwick Valley","lines":["Teriha"], "date": "10/10/09"},
    {"label":"Puerto Vallarta","lines":["Liza","Vicky"], "date": "10/29/09"},
    {"label":"Mexican Honeymoon","lines":["Liza"], "date": "10/29/09"},
    {"label":"The Shire","lines":["Calvin","Rahul","Todd","Liza","Hiro","Priya"], "date": "1/11/10"},
    {"label":"Birthday Kidnapping","lines":["Calvin","Rahul","Todd","Christian","Teriha"], "date": "1/29/10"},
    {"label":"Cage Fighting","lines":["Brandon","Angela","Calvin","Rahul","Todd","Christian","Liza","Katie","Vicky","Hiro","Priya"], "date": "1/29/10"},
    {"label":"Virginia Cabin","lines":["Liza","Vicky","Hiro"], "date": "3/19/10"},
    {"label":"DreamIt Philadelphia","lines":["Todd"],"date": "5/29/2010"},
    {"label":"Maine","lines":["Liza","Vicky","Hiro"],"date": "5/27/2011"},
    {"label":"Juice Party","lines":["Liza","Katie","Vicky","Todd","Becky"],"date": "6/4/2011"},
    {"label":"New Hampshire Camping","lines":["Dad","Brandon"],"date": "6/22/2011"},
    {"label":"Miami Wedding","lines":["Patricia","Michelle S"],"date": "7/30/2011"},
    {"label":"Oriental Garden Birthday","lines":["Calvin","Christian","Cynthia"],"date": "12/5/2011"},
    {"label":"Tree Decorating","lines":["Liza","Katie","Hiro","Vicky","Becky","Amanda","Todd"],"date": "12/11/2011"},
    {"label":"Breakneck / Storm King","lines":["Becky"],"date": "12/29/2011"},
    {"label":"Paint Party / Little Stripper","lines":["Brandon","Angela","Hoang","Stephanie","Calvin","Rahul","Liza","Katie","Hiro","Becky","Priya","Amanda"],"date": "1/29/2012"},
    {"label":"Puerto Rico","lines":["Liza","Katie","Vicky"],"date": "2/26/2012"},
    {"label":"Sketch Night","lines":["Becky"]},
    {"label":"Central Park Collabo-Art","lines":["Cynthia"],"date": "5/12/2012"},
    {"label":"World Science Festival","lines":["Hoang"],"date": "6/2/2012"},
    {"label":"Color Run","lines":["Angela"],"date": "6/18/2012"},
    {"label":"Bermuda Cruise","lines":["Mom","Dad","Brandon"],"date": "6/30/2012"},
    {"label":"First Joyathon","lines":["Angela","Stephanie","Calvin","Christian","Cynthia","Virginia"],"date": "9/13/2012"},
    {"label":"Hurricane Sandy","lines":["Liza","Michelle H","Thomas"],"date": "10/29/2012"},
    {"label":"Gay Halloween","lines":["Liza","Michelle H","Thomas"]},
    {"label":"Homeland","lines":["Liza","Michelle H","Thomas"]},
    {"label":"New Orleans","lines":["Liza","Becky","Amanda"],"date": "1/9/2013"},
    {"label":"Chinatown Pho & Boba","lines":["Michelle H"]},
    {"label":"Sketchy Film at MoMA","lines":["Michelle H"]},
    {"label":"Curling","lines":["Liza","Becky"],"date":"4/21/2013"},
    {"label":"Kidney Stones","lines":["Liza","Michelle H","Thomas"]},
    {"label":"Children's Museum","lines":["Hoang"]},
    {"label":"Odie","lines":["Liza","Michelle H","Thomas"],"date": "7/4/2013"},
    {"label":"July 4th Wedding","lines":["Michelle S","Stephanie"],"date": "7/4/2013"},
    {"label":"Late Night Ippudo","lines":["Michelle H","Thomas"]},
    {"label":"First Turing Meeting","lines":["Virginia"]},
    {"label":"Harlem Scavenger Hunt","lines":["Patricia"]},
    {"label":"The National","lines":["Virginia"]},
    {"label":"Queens Art Walk","lines":["Teriha"]}
  ]
}



// WEBPACK FOOTER //
// ./src/data.js